import {MouseEvent, useContext, useEffect, useRef, useState} from "react";
import {EditContext} from "../../../../misc/scroller/EditProvider";
import {editCellPadding} from "../../../../misc/scroller/TableEditCell";
import {Button, Checkbox, FormControlLabel, Tooltip} from "@mui/material";
import {Popover} from "../../../../misc/Popover";

export function MultiStateCheckboxEl<T>(props: {
    style?: any;

    checkedA: boolean;
    labelA: string;

    checkedB: boolean;
    labelB: string;

    disabled?: boolean;
    onChange(a: boolean, b: boolean): T
}) {
    const edit = useContext(EditContext);
    const inputRef = useRef<HTMLInputElement>(null);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [popupA, setPopupA] = useState(props.checkedA);
    const [popupB, setPopupB] = useState(props.checkedB);

    const indeterminate = props.checkedA !== props.checkedB;
    const allChecked = props.checkedA && props.checkedB;

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    const onClick = () => {
        if (props.disabled) return;

        if (indeterminate) {
            edit.update(props.onChange(true, true));
        } else {
            const next = !allChecked;
            edit.update(props.onChange(next, next));
        }
    };

    const onCancel = () => setAnchorEl(null);

    const onSave = () => {
        edit.update(props.onChange(popupA, popupB));
        setAnchorEl(null);
    };

    return (
        <div style={Object.assign({display: "flex", justifyContent: "center",
            height: 20,
            marginLeft: -editCellPadding.left,
            marginRight: -editCellPadding.right,
            marginTop: -editCellPadding.top - 2,
            marginBottom: -editCellPadding.bottom - 2,
        }, props.style)}
             onContextMenu={(e: MouseEvent<HTMLElement>) => {
                 e.preventDefault();
                 if (props.disabled) return;
                 setPopupA(props.checkedA);
                 setPopupB(props.checkedB);
                 setAnchorEl(e.currentTarget);
             }}
        >
            <Tooltip title="Right click for more options">
                <input
                    ref={inputRef}
                    disabled={props.disabled}
                    type="checkbox"
                    checked={allChecked}
                    onChange={onClick}
                />
            </Tooltip>
            {anchorEl && <Popover
                open
                anchorEl={anchorEl}
                onClose={onCancel}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <div style={{padding: 8, display: "flex", flexDirection: "column"}}>
                    <FormControlLabel
                        control={<Checkbox size="small" checked={popupA} onChange={e => setPopupA(e.target.checked)} />}
                        label={props.labelA}
                    />
                    <FormControlLabel
                        control={<Checkbox size="small" checked={popupB} onChange={e => setPopupB(e.target.checked)} />}
                        label={props.labelB}
                    />
                    <div style={{display: "flex", justifyContent: "flex-end", gap: 4, marginTop: 4}}>
                        <Button size="small" onClick={onCancel}>Cancel</Button>
                        <Button size="small" variant="contained" onClick={onSave}>Save</Button>
                    </div>
                </div>
            </Popover>}
        </div>
    )
}
